import { container } from '../services/container'
import { Order } from '../core/Order'
import { Repository } from '../services/Repository'

function _orderControl(user, to, from, next) {

	if (user.order.closed) {
		next({name: 'recipes'})
		return
	}

	if (user.subscription && user.subscription.status === 'pending') {
		next({name: 'flow-subscribed'})
		return
	} 

	next();
};

export default {

	orderControlOrGuest (to, from, next) {
		var user = container.get('user')

		if (!user) {
			next({name: 'flow-subscribed'})
			return
		}

		return _orderControl(user, to, from, next);
	},

	orderControl (to, from, next) {
		var user = container.get('user') && !container.get('user').email.includes('guest.quomi.it')
			? container.get('user')
			: null

		if (!user || !user.order || user.isNew()) {
			next({name: 'flow-subscribed'})
			return
		}

		return _orderControl(user, to, from, next);
	},

	shopControl (to, from, next) {
		var user = container.get('user') && !container.get('user').email.includes('guest.quomi.it')
			? container.get('user')
			: null

		var userHasOrder = user
			&& user.order
			&& user.order.is_ok

		var isSubscriptionActive = user
			&& user.subscription
			&& user.order
			&& !user.order.is_skip
			&& !user.subscription.is_suspended
		next(userHasOrder && isSubscriptionActive ? { name: 'ecommerce' } : true)
	},

	dashboardController (to, from, next) {
		var user = container.get('user')
		const userSubscribed = () => user && user.isSubscribed()
		if (to.name === 'home') {
			next(userSubscribed() ? { name: 'dashboard' } : true)
			return
		}

		if (to.name === 'dashboard') {
			 next(userSubscribed() ? true : { name: 'home' })
		}
	},

	closedOrder (to, from, next) {
		var user = container.get('user')

		const userSubscribed = () => user && user.isSubscribed()
		const orderClosed = () => user && user.order && user.order.closed

		next(userSubscribed() && !orderClosed() ? { name: 'flow-subscribed' } : true)
	},

	new (to, from, next) {
		var user = container.get('user')
		const userSubscribed = () => user && user.isSubscribed()

		next(userSubscribed() ? { name: 'flow-subscribed' } : true)
	},

	subscribed (to, from, next) {
		var user = container.get('user')
		const orderClosed = () => user && user.order && user.order.closed
		const userNew = () => !user || user.isNew()

    const subLocked = () => user && user.subscription && user.subscription.locked

    if (subLocked()) {
      next({name: 'subscription.locked'})
      return
    }
    
		if (orderClosed()) {
			next({name: 'recipes'})
			return
		}

		if (userNew()) {
			next({name: 'flow-new'})
			return
		}
		next()
	},

	checkClosed (to, from, next) {
		var user = container.get('user')

    if (user && user.source == 'order-now') {
      next({name: 'order-now'})
      return
    }

		const orderClosed = () => user && user.order && user.order.closed

		if (orderClosed()) {
			next({name: 'recipes'})
			return
		}
		const subLocked = () => user && user.subscription && user.subscription.locked

		if (subLocked()) {
			next({name: 'subscription.locked'})
			return
		}

		next()
	},


	subscribedOrGuest (to, from, next) {
		var user = container.get('user')
		const orderClosed = () => user && user.order && user.order.closed

		if (orderClosed()) {
			next({name: 'recipes'})
			return
		}


		if (!user || !user.subscription) {
			let rep = new Repository();
			return rep.createGuestWithEmtpyOrder().then(next)
		}


		next()
	},

	profileControl (to, from, next) {
		var user = container.get('user') && !container.get('user').email.includes('guest.quomi.it')

		next(user ? true : {
			name: 'home'
		})
	},

	freshdesk (to, from, next) {
		var user = container.get('user') && !container.get('user').email.includes('guest.quomi.it')

		next(user ? true : {
			name: 'login-page', query: { redir: 'supporto' }
		})
	}
}
